import _classCallCheck from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/createClass";
import _get from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/createSuper";
import { ValueWithRandom } from "../../ValueWithRandom";
import { setRangeValue } from "../../../../Utils/NumberUtils";
export var Repulse = /*#__PURE__*/function (_ValueWithRandom) {
  _inherits(Repulse, _ValueWithRandom);
  var _super = _createSuper(Repulse);
  function Repulse() {
    var _this;
    _classCallCheck(this, Repulse);
    _this = _super.call(this);
    _this.enabled = false;
    _this.distance = 1;
    _this.duration = 1;
    _this.factor = 1;
    _this.speed = 1;
    return _this;
  }
  _createClass(Repulse, [{
    key: "load",
    value: function load(data) {
      _get(_getPrototypeOf(Repulse.prototype), "load", this).call(this, data);
      if (!data) {
        return;
      }
      if (data.enabled !== undefined) {
        this.enabled = data.enabled;
      }
      if (data.distance !== undefined) {
        this.distance = setRangeValue(data.distance);
      }
      if (data.duration !== undefined) {
        this.duration = setRangeValue(data.duration);
      }
      if (data.factor !== undefined) {
        this.factor = setRangeValue(data.factor);
      }
      if (data.speed !== undefined) {
        this.speed = setRangeValue(data.speed);
      }
    }
  }]);
  return Repulse;
}(ValueWithRandom);